import { EventsManager } from '@game-libs/events-manager';
import { useGameDispatch } from '../global-context';
import { useGameStatusStore } from '../zustand/useGameStatusStore';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { QuickGameDialog } from '@game-libs/quick-game-dialog';
import { CONFIG } from '../../config';
import { GUIActions } from '../../types/game-types';

export const useFirstManaOutDialog = () => {
  const dispatch = useGameDispatch();
  const shownFirstManaOutDialog = useGameStatusStore((s) => s.shownFirstManaOutDialog);
  const { i18n } = useTranslation();
  const hasShownThisSessionRef = useRef(false);
  const { on } = EventsManager();

  useEffect(() => {
    const unsub = on(GUIActions.NOT_ENOUGH_MANA, () => {
      if (CONFIG.game.skipDialogs) return;
      if (shownFirstManaOutDialog || hasShownThisSessionRef.current) return;

      hasShownThisSessionRef.current = true;
      dispatch({ type: GUIActions.SHOWN_FIRST_MANA_OUT_DIALOG });

      const { openDialog } = QuickGameDialog({
        pathToInkFiles: './dialogs',
        pathToSpeakerFiles: './dialogs/pictures',
        containerId: 'ui-wrapper',
      });

      openDialog('mana_out', i18n.language, true);
    });

    return () => unsub?.();
  }, [dispatch, shownFirstManaOutDialog, i18n.language]);
};
